import { gql } from '@apollo/client';

export const GET_PLANNER_ITEM_THUMBNAIL_QUERY = gql`
    query GetPlannerItemThumbnailQuery($plannerId: ID!) {
        plannerEvent(id: $plannerId) {
            ... on PlannerEvent {
                id
                publishedArtifact {
                    id
                    thumbnails {
                        small {
                            url
                        }
                    }
                }
                suggestedTemplate {
                    ... on BuildableTemplate {
                        id
                        currentVersion {
                            id
                            thumbnailUrl
                        }
                    }
                    ...on BuilderTemplate {
                        id
                        thumbnailUrl
                    }
                }
            }
        }
    }
`;
